/*
 * @Author: qinqianwen
 * @Date: 2020-08-04 09:06:19
 * @LastEditTime: 2020-08-28 14:33:45
 * @LastEditors: Please set LastEditors
 * @Description: 货物管理模块api
 * @FilePath: \e6-module-base-data\src\e6-module-base-data\api\goodsManage.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleBaseDataApi } from "@/config/api";
const { host = "", E6_MS_TMS_BASE_WEB = "" } = e6ModuleBaseDataApi;

//获取货物管理列表数据
export function getGoodsList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/goods/info/page`,
    method: "post",
    data
  });
}
//新增货物信息
export function addGoodsInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/goods/info/save`,
    method: "post",
    data
  });
}
//修改货物信息
export function updateGoodsInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/goods/info/update`,
    method: "post",
    data
  });
}

//查询货物详细信息
export function fetchGoodsDetail(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/goods/info/findGoodsInfoById`,
    method: "get",
    params
  });
}
//批量删除货物信息
export function batchDeleteGoodsInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/goods/info/batch`,
    method: "post",
    data
  });
}
//查询更改记录
export function fetchUpdateRecord(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/goods/info/history/page`,
    method: "post",
    data
  });
}
//货物名称唯一性校验
export function checkGoodsNameUnicode(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/goods/info/checkGoodName`,
    method: "get",
    params
  });
}
//货物编码唯一性校验
export function checkGoodsNoUnicode(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/goods/info/checkGoodNo`,
    method: "get",
    params
  });
}
//导出
export function exportGoodsInfo(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_BASE_WEB}/goods/info/export`,
    method: "post",
    data
  });
}

// TODO: 一期迭代功能不上
//********************* 货物更改记录 ****************** */
//获取货物更改记录列表数据
export function getGoodsUpdateRecord(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/goods/info/findGoodsHistoryByPage`,
    method: "post",
    data
  });
}
